import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/jb-social-icons/jb-social-icons.css.ts
var jb_social_icons_css_default = i`ul{align-items:center;display:flex;flex-wrap:nowrap;gap:var(--social-icons-gap, var(--spacing-2xs));justify-content:center}@media(min-width: 1281px){ul{gap:var(--social-icons-gap, var(--spacing-s))}}ul li{list-style:none}ul li jb-anchor{align-items:center;block-size:40px;display:flex;height:100%;inline-size:40px;justify-content:center;scale:1;transition:scale .3s ease-in-out}ul li jb-anchor:hover{scale:1.2}ul.start,ul.left{justify-content:start}ul.right,ul.end{justify-content:end}`;

export {
  jb_social_icons_css_default
};
